import EntityImageActions from '../../entityImage/EntityImageActions';

const UserImageActions = () => <EntityImageActions entityType="user" />;

export default UserImageActions;
